import { ProductMemberDto } from '@models';

export const hasWarning = (member: ProductMemberDto, deviations: string[]) => {
  return deviations.includes(member.email);
};
